import { API_TEMPLATE } from '../libs/constant'
import { post, get } from '../libs/query'
import { formatUrl } from '../libs/url'

const ticketApi = {
  assign ({ taskId, userId }) {
    const path = API_TEMPLATE.TICKET_ASSIGN
    return post(`${path}?taskId=${taskId}&userId=${userId}`)
  },
  assignByClassDemoId ({ taskId, userId }) {
    const path = API_TEMPLATE.TICKET_ASSIGN_BY_CLASS_DEMO_ID
    return post(`${path}?classDemoId=${taskId}&monitorId=${userId}`)
  },
  assignMultiple ({ userId, ids }) {
    return post(API_TEMPLATE.TICKET_ASSIGN_MULTIPLE, { userId, ids })
  },
  assignMultipleByFilter (payload, isDivideEvenly) {
    return post(`${API_TEMPLATE.TICKET_ASSIGN_MULTIPLE_BY_FILTER}?isDivideEvenly=${isDivideEvenly}`, payload)
  },
  cancel (id) {
    return post(`${API_TEMPLATE.TICKET_CANCEL}?id=${id}`)
  },
  assignMultipleMonitor ({ userId, ids }) {
    return post(`${API_TEMPLATE.TICKET_MONITOR_ASSIGN_MULTIPLE}`, { userId, taskIds: ids })
  },
  // list ({ criteria, page, size }) {
  //   const path = API_TEMPLATE.TICKET_FILTER
  //   return post(path, { criteria, page, size })
  // },
  // selfAssign (id) {
  //   return post(`${API_TEMPLATE.TICKET_SELF_ASSIGN}?id=${id}`)
  // },
  // createTechnical (payload) {
  //   return post(API_TEMPLATE.TICKET_CREATE_TECHNICAL, payload)
  // },

  detail (id) {
    const path = formatUrl(API_TEMPLATE.TICKET_DETAIL, [
      { key: 'id', value: id }
    ])
    return get(path)
  },
  differentResult ({ orderDataId, beforeAt }) {
    return get(`${API_TEMPLATE.TICKET_DIFFERENT_RESULT}?orderDataId=${orderDataId}&beforeAt=${beforeAt}`)
  },

  exportBeforeExpired ({ payload, sheetId, sheetName }) {
    return post(`${API_TEMPLATE.TICKET_EXPORT_BEFORE_EXPIRED}?sheetId=${sheetId}&sheetName=${sheetName}`, payload)
  },

  exportFirstTime ({ payload, sheetId, sheetName }) {
    return post(`${API_TEMPLATE.TICKET_EXPORT_FIRST_TIME}?sheetId=${sheetId}&sheetName=${sheetName}`, payload)
  },

  exportPeriodical ({ payload, sheetId, sheetName }) {
    return post(`${API_TEMPLATE.TICKET_EXPORT_PERIODICAL}?sheetId=${sheetId}&sheetName=${sheetName}`, payload)
  },

  exportReportResult ({ payload, sheetId, sheetName }) {
    return post(`${API_TEMPLATE.TICKET_EXPORT_REPORT_RESULT}?sheetId=${sheetId}&sheetName=${sheetName}`, payload)
  },

  exportTechnical ({ payload, sheetId, sheetName }) {
    return post(`${API_TEMPLATE.TICKET_EXPORT_TECHNICAL}?sheetId=${sheetId}&sheetName=${sheetName}`, payload)
  },

  findByStudentAndSession ({ studentId, sessionId }) {
    return get(`${API_TEMPLATE.TICKET_FIND_TECHNICAL_BY_STUDENT_SESSION}?studentId=${studentId}&sessionId=${sessionId}`)
  },

  list ({ criteria, page, size }) {
    const path = API_TEMPLATE.TICKET_MONITOR_FILTER
    return post(path, { criteria, page, size })
  },
  listTicketMonitorFilter ({ criteria, page, size }) {
    const path = API_TEMPLATE.TICKET_MONITOR_FILTER
    return post(path, { criteria, page, size })
  },

  list_report_learned_result (studentId) {
    const path = API_TEMPLATE.TICKET_LIST_REPORT_LEARNED_RESULT
    return get(`${path}?studentId=${studentId}`)
  },

  selfAssign (id) {
    return post(`${API_TEMPLATE.TICKET_SUPPORT_TECHNICAL_ASSIGN_SELF}?id=${id}`)
  },

  updateAfterStart (payload) {
    return post(API_TEMPLATE.TICKET_UPDATE_AFTER_START, payload)
  },

  updateBeforeExpire (payload) {
    return post(API_TEMPLATE.TICKET_UPDATE_BEFORE_EXPIRE, payload)
  },
  updateFeedBack (payload) {
    return post(API_TEMPLATE.TICKET_UPDATE_FEEDBACK, payload)
  },

  updateMonitor (payload) {
    return post(API_TEMPLATE.TICKET_UPDATE_MONITOR, payload)
  },

  updateReportResult (payload) {
    return post(API_TEMPLATE.TICKET_UPDATE_REPORT_RESULT, payload)
  },

  updatePeriodical (payload) {
    return post(API_TEMPLATE.TICKET_UPDATE_PERIODICAL, payload)
  },

  // updateTechnical (payload) {
  //   return post(API_TEMPLATE.TICKET_UPDATE_TECHNICAL, payload)
  // },

  updateTechnicalTime ({ sessionId, studentId, timeToSupport }) {
    return post(API_TEMPLATE.TICKET_UPDATE_TECHNICAL_TIME, { sessionId, studentId, timeToSupport })
  },

  assignDemoReschedule ({ id, userId }) {
    const path = API_TEMPLATE.TICKET_DEMO_RESCHEDULE_ASSIGN
    return post(path, { id, userId })
  },

  updateExpectedLearnDateDemoReschedule({ id, estimatedExpiredDate }) {
    const path = API_TEMPLATE.TICKET_DEMO_RESCHEDULE_UPDATE_EXPECT_LEARN_DATE
    return post(path, { id, estimatedExpiredDate })
  },

  addNoteTicketDemoReschedule({ id, note }) {
    const path = API_TEMPLATE.TICKET_DEMO_RESCHEDULE_ADD_NOTE
    return post(path, { id, note })
  }
}

export default ticketApi
